var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"relative",attrs:{"id":"app"}},[_c('nav-bar',{ref:"header",attrs:{"nav-bar-fixed":_vm.navBarFixed}}),_c('router-view',{ref:"index"}),_c('footer-view',{ref:"footer",class:{'footer-wrapper': _vm.is_position}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }